import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import { NoticeBox } from '@core/Components/NoticeBox'
import { GridCell } from '@mobi/component-library/Legacy/Grid'
import { fetchFromApi } from '@classic/Foundation/Services/ApiService'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { SpecialsErrorNoticeBoxStyled } from './SpecialsPage'

export const SpecialsTermsPage = (): JSX.Element => {
  const fetchSpecialsTerms = () =>
    fetchFromApi('/cms/specials-terms').then(response => response.text())
  const { isLoading, isError, data } = useQuery<string>({
    queryKey: [queryKeys.specialsTerms],
    queryFn: fetchSpecialsTerms,
    retry: false,
  })

  if (isLoading) {
    return (
      <GridCell padding='0 1rem'>
        <LoadingPlaceholder width='100%' height='2rem' />
        <LoadingPlaceholder width='100%' height='2rem' />
        <LoadingPlaceholder width='100%' height='2rem' />
      </GridCell>
    )
  }

  if (isError) {
    return (
      <SpecialsErrorNoticeBoxStyled>
        <NoticeBox
          title='Unable to display Superpick terms and conditions at this time. Please try again later.'
          noticeBoxType='Info'
          hasBorder
        />
      </SpecialsErrorNoticeBoxStyled>
    )
  }

  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: data || '' }} />
}
